export default {
  Lang: state => state.lang,
  Isloading: state => state.isloading,
  GetPath: state => state.path,
}